import React from 'react'
import { SelectChangeEvent } from '@mui/material'

import { Select } from '@/components'
import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { sbpPaymentsActions } from '@/stores/slices/sbp-payments-slice.ts'

const MENU_ITEMS = [
  { value: 'ALL', label: 'Все' },
  { value: 'NEW', label: 'Запрос к получателю' },
  { value: 'PROCESSING', label: 'В работе' },
  { value: 'PAID', label: 'Успешно' },
  { value: 'REJECTED', label: 'Неуспешно' },
]

export const ToCStatusFilter = (): React.ReactElement => {
  const state = useAppSelector((state) => state.sbpPayments.transferState)
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(
      sbpPaymentsActions.setFilter({
        filterKey: 'transferState',
        filterValue: event.target.value === 'ALL' ? '' : event.target.value,
      })
    )
  }

  const selectValue = state || 'ALL'

  return (
    <Select value={selectValue} onChange={handleStatusChange} items={MENU_ITEMS} label="Статус" labelId="sbp-status" />
  )
}
